import * as R from "ramda";

import "../date";


/** A function that returns raw value if it's a date or parses it as a JSON date if it's a string. */
export const asDate = R.ifElse(R.is(Date), R.identity, Date.fromJSONDate);

export function debounce(callback: any, timeout: any): () => void {
    let timeoutInstance: number = -1;
    return function (): void {
        if (timeoutInstance !== -1) { clearTimeout(timeoutInstance); }
        timeoutInstance = setTimeout(callback, timeout);
    };
}

export function propOrDefault(field: any, defaultValue: any): (item: any) => any {
    return function (item: any): any {
        if (item === undefined || item === null) {
            return defaultValue;
        }
        const  value = item[field];
        if (value === undefined || value === null) {
            return defaultValue;
        }
        return value;
    };
}

export function convertToString(defaultValue: string): (value: any) => string {
    return function (value: any): string {
        if (typeof value === "string") {
            return value;
        } else if (value !== null && value !== undefined && typeof value.toString === "function") {
            return value.toString();
        } else {
            return defaultValue;
        }
    };
}

/**
 * Gets the index of the first column to which an aggregator has been applied.
 *
 * @param gridColumns
 *     Array of grid columns currently being rendered.
 * @param aggregators
 *     Array of SlickGrid aggregator instances that contain column name in a "field_" property.
 * @returns
 *     Index of the first column to which an aggregator has been applied or -1 if
 *     no aggregates were specified.
 */
export function findFirstAggregateColumn(gridColumns: any, aggregators: any): number {
    if (!Array.isArray(gridColumns)) { throw new Error("Expected \"gridColumns\" to be an array of grid columns."); }
    if (!Array.isArray(aggregators)) { throw new Error("Expected \"aggregators\" to be an array of Aggregator objects."); }

    const aggregatedColumns = R.uniq(R.pluck("field_", aggregators));

    let index: number;
    for (let c = 0; c < gridColumns.length; c += 1) {
        index = aggregatedColumns.indexOf(gridColumns[c].field);
        if (index >= 0) {
            return c;
        }
    }
    return -1;
}

export function stringOrDefault(field: any, defaultValue: any): any {
    return R.compose(convertToString(defaultValue), propOrDefault(field, defaultValue));
}



// WEBPACK FOOTER //
// /Users/johng/dev/web-pli/ko-grid/util.ts